module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3wUrP"))).then(() => parcelRequire('2KbAe'));